import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaFileUploadGalleryItem from './VaFileUploadGalleryItem.vue'

export const VaFileUploadGalleryItem = withConfigTransport(_VaFileUploadGalleryItem)
